import React from 'react';
import { needAmount, needMoney } from '@/lib/materialNeedTotals';
const number = value => Number(value || 0).toLocaleString('es-ES', { maximumFractionDigits: 4 });

export function NeedProductImage({ image, description }) {
  return image ? <img src={image} alt={description || 'Producto'} loading="lazy" className="h-20 w-20 shrink-0 rounded border bg-white object-contain" /> : <div className="flex h-20 w-20 shrink-0 items-center justify-center rounded border bg-gray-50 text-xs font-normal text-gray-500">Sin foto</div>;
}

export function MaterialNeedDetail({ need, showArticle = true }) {
  return <div className="flex gap-3 py-2 text-xs font-normal">
    {showArticle && <NeedProductImage image={need.image} description={need.description} />}
    <div className="min-w-0 space-y-1">
      {showArticle && <><div className="font-medium">{need.article} · {need.description}</div><div>{number(need.garments)} prendas</div><div>{need.name}{need.color_usage ? ` · ${need.color_usage}` : ''}</div></>}
      <div>Proceso: {need.process || need.process_name || 'Sin proceso'}</div>
      <div>Consumo: {number(need.quantity_per_unit)} {need.unit}/prenda · Merma: {number(need.waste_pct)}%</div>
      <div>Precio: {needMoney(need.unit_cost)} / {need.unit} · Necesidad: {number(need.needed)} {need.unit}</div>
      <div className="font-medium">Importe: {needMoney(needAmount(need))}</div>
      {need.supplier_description && <div>{need.supplier_description}</div>}
      {need.notes && <div className="whitespace-pre-wrap">{need.notes}</div>}
    </div>
  </div>;
}
